import { createActions, createReducer } from 'reduxsauce'

const listaPagos = [
    { value: '', label: 'Todas' },
    { value: 'S', label: 'Sim' },
    { value: 'N', label: 'Não' },
]

const listaTipoCompra = [
    { value: null, label: 'Nenhum' },
    { value: 1, label: 'Empenho' },
    { value: 2, label: 'Ata de Registro de Preço' },
    { value: 3, label: 'Contrato' },
    { value: 4, label: 'Convênio' },
]

/**
 * Action types & creators
 */

export const { Types, Creators } = createActions({
    setAdministracaoConsultaEmpenhoCredorAquisicoesDiretas: ['administracao'],
    setExercicioEmpenhoInicialConsultaEmpenhoCredorAquisicoesDiretas: ['exercicioEmpenhoInicial'],
    setExercicioEmpenhoFinalConsultaEmpenhoCredorAquisicoesDiretas: ['exercicioEmpenhoFinal'],
    setNumeroEmpenhoInicialConsultaEmpenhoCredorAquisicoesDiretas: ['numeroEmpenhoInicial'],
    setNumeroEmpenhoFinalConsultaEmpenhoCredorAquisicoesDiretas: ['numeroEmpenhoFinal'],
    setDataEmpenhoInicialConsultaEmpenhoCredorAquisicoesDiretas: ['dataEmpenhoInicial'],
    setDataEmpenhoFinalConsultaEmpenhoCredorAquisicoesDiretas: ['dataEmpenhoFinal'],
    setDataVencimentoInicialConsultaEmpenhoCredorAquisicoesDiretas: ['dataVencimentoInicial'],
    setDataVencimentoFinalConsultaEmpenhoCredorAquisicoesDiretas: ['dataVencimentoFinal'],
    setPagosConsultaEmpenhoCredorAquisicoesDiretas: ['pagos'],
    setRecursoConsultaEmpenhoCredorAquisicoesDiretas: ['recurso'],
    setDestinacaoConsultaEmpenhoCredorAquisicoesDiretas: ['destinacao'],
    setNomeCredorConsultaEmpenhoCredorAquisicoesDiretas: ['nomeCredor'],
    setCnpjConsultaEmpenhoCredorAquisicoesDiretas: ['cnpj'],
    setCpfConsultaEmpenhoCredorAquisicoesDiretas: ['cpf'],
    setDocumentoConsultaEmpenhoCredorAquisicoesDiretas: ['documento'],
    setExercicioProtocoloInicialConsultaEmpenhoCredorAquisicoesDiretas: ['exercicioProtocoloInicial'],
    setExercicioProtocoloFinalConsultaEmpenhoCredorAquisicoesDiretas: ['exercicioProtocoloFinal'],
    setNumeroProtocoloInicialConsultaEmpenhoCredorAquisicoesDiretas: ['numeroProtocoloInicial'],
    setNumeroProtocoloFinalConsultaEmpenhoCredorAquisicoesDiretas: ['numeroProtocoloFinal'],
    setProcessoReferenciaConsultaEmpenhoCredorAquisicoesDiretas: ['processoReferencia'],
    setTipoCompraConsultaEmpenhoCredorAquisicoesDiretas: ['tipoCompra'],
    setBaseLegalConsultaEmpenhoCredorAquisicoesDiretas: ['baseLegal'],
    limpaFiltroConsultaEmpenhoCredorAquisicoesDiretas: [],
    receberFiltroConsultaEmpenhoCredorAquisicoesDiretas: ['filtroRecebido'],
})

const INITIAL_STATE = {
    administracao: [],
    exercicioEmpenhoInicial: '',
    exercicioEmpenhoFinal: '',
    numeroEmpenhoInicial: '',
    numeroEmpenhoFinal: '',
    dataEmpenhoInicial: '',
    dataEmpenhoFinal: '',
    dataVencimentoInicial: '',
    dataVencimentoFinal: '',
    pagos: { value: listaPagos[0].value, label: listaPagos[0].label },
    recurso: [],
    destinacao: [],
    nomeCredor: '',
    cnpj: '',
    cpf: '',
    documento: '',
    exercicioProtocoloInicial: '',
    exercicioProtocoloFinal: '',
    numeroProtocoloInicial: '',
    numeroProtocoloFinal: '',
    processoReferencia: '',
    tipoCompra: { value: listaTipoCompra[0].value, label: listaTipoCompra[0].label },
    baseLegal: [],
}

const setAdministracao = (state = INITIAL_STATE, action) => {
    return { ...state, administracao: action.administracao }
}
const setExercicioEmpenhoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioEmpenhoInicial: action.exercicioEmpenhoInicial }
}
const setExercicioEmpenhoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioEmpenhoFinal: action.exercicioEmpenhoFinal }
}
const setNumeroEmpenhoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, numeroEmpenhoInicial: action.numeroEmpenhoInicial }
}
const setNumeroEmpenhoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, numeroEmpenhoFinal: action.numeroEmpenhoFinal }
}
const setDataEmpenhoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataEmpenhoInicial: action.dataEmpenhoInicial }
}
const setDataEmpenhoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataEmpenhoFinal: action.dataEmpenhoFinal }
}
const setDataVencimentoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataVencimentoInicial: action.dataVencimentoInicial }
}
const setDataVencimentoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataVencimentoFinal: action.dataVencimentoFinal }
}
const setPagos = (state = INITIAL_STATE, action) => {
    return { ...state, pagos: action.pagos }
}
const setRecurso = (state = INITIAL_STATE, action) => {
    return { ...state, recurso: action.recurso }
}
const setDestinacao = (state = INITIAL_STATE, action) => {
    return { ...state, destinacao: action.destinacao }
}
const setNomeCredor = (state = INITIAL_STATE, action) => {
    return { ...state, nomeCredor: action.nomeCredor }
}
const setCnpj = (state = INITIAL_STATE, action) => {
    return { ...state, cnpj: action.cnpj }
}
const setCpf = (state = INITIAL_STATE, action) => {
    return { ...state, cpf: action.cpf }
}
const setDocumento = (state = INITIAL_STATE, action) => {
    return { ...state, documento: action.documento }
}

const setExercicioProtocoloInicial = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioProtocoloInicial: action.exercicioProtocoloInicial }
}
const setExercicioProtocoloFinal = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioProtocoloFinal: action.exercicioProtocoloFinal }
}
const setNumeroProtocoloInicial = (state = INITIAL_STATE, action) => {
    return { ...state, numeroProtocoloInicial: action.numeroProtocoloInicial }
}
const setNumeroProtocoloFinal = (state = INITIAL_STATE, action) => {
    return { ...state, numeroProtocoloFinal: action.numeroProtocoloFinal }
}

const setProcessoReferencia = (state = INITIAL_STATE, action) => {
    return { ...state, processoReferencia: action.processoReferencia }
}

const setTipoCompra = (state = INITIAL_STATE, action) => {
    return { ...state, tipoCompra: action.tipoCompra }
}

const setBaseLegal = (state = INITIAL_STATE, action) => {
    return { ...state, baseLegal: action.baseLegal }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_ADMINISTRACAO_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: setAdministracao,
    [Types.SET_EXERCICIO_EMPENHO_INICIAL_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: setExercicioEmpenhoInicial,
    [Types.SET_EXERCICIO_EMPENHO_FINAL_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: setExercicioEmpenhoFinal,
    [Types.SET_NUMERO_EMPENHO_INICIAL_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: setNumeroEmpenhoInicial,
    [Types.SET_NUMERO_EMPENHO_FINAL_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: setNumeroEmpenhoFinal,
    [Types.SET_DATA_EMPENHO_INICIAL_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: setDataEmpenhoInicial,
    [Types.SET_DATA_EMPENHO_FINAL_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: setDataEmpenhoFinal,
    [Types.SET_DATA_VENCIMENTO_INICIAL_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: setDataVencimentoInicial,
    [Types.SET_DATA_VENCIMENTO_FINAL_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: setDataVencimentoFinal,
    [Types.SET_PAGOS_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: setPagos,
    [Types.SET_RECURSO_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: setRecurso,
    [Types.SET_DESTINACAO_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: setDestinacao,
    [Types.SET_NOME_CREDOR_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: setNomeCredor,
    [Types.SET_CNPJ_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: setCnpj,
    [Types.SET_CPF_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: setCpf,
    [Types.SET_DOCUMENTO_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: setDocumento,
    [Types.SET_EXERCICIO_PROTOCOLO_INICIAL_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: setExercicioProtocoloInicial,
    [Types.SET_EXERCICIO_PROTOCOLO_FINAL_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: setExercicioProtocoloFinal,
    [Types.SET_NUMERO_PROTOCOLO_INICIAL_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: setNumeroProtocoloInicial,
    [Types.SET_NUMERO_PROTOCOLO_FINAL_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: setNumeroProtocoloFinal,
    [Types.SET_PROCESSO_REFERENCIA_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: setProcessoReferencia,
    [Types.SET_TIPO_COMPRA_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: setTipoCompra,
    [Types.SET_BASE_LEGAL_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: setBaseLegal,
    [Types.LIMPA_FILTRO_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: receberFiltro,
})
